import React, { useState, useEffect, useContext, useMemo } from "react";
import { Navigate } from 'react-router-dom';
import axios from "axios";
import moment from "moment";
import DataTable from "react-data-table-component";
import styled from "styled-components";
import { makeStyles } from "@mui/styles";
import LinearProgress from "@mui/material/LinearProgress";
import Tooltip from "@mui/material/Tooltip";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CheckIcon from "@mui/icons-material/Check";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import EditIcon from "@mui/icons-material/Edit";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";

import UserService from "services/UserService";
import { getActionPlan, deleteAction } from "services/ConfigServices";
import { ActionContext } from "context/ActionContext";
import { IntInput, FloatInput } from "components/Input/Index.js";
import useActionTable from "./useActionTable.js";

//import "react-table/react-table.css";

// @mui/icons-material

import Button from "components/CustomButtons/Button.js";

const useStyles = makeStyles(styles);

const TableName = styled.div`
  margin-right: auto;
  margin-left: -8px;
  font-size: 1.3rem;
  font-weight: 500;
`;

const RTWalls = ({ planActionId, planActionName }) => {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const actionplanupdate = permis.includes("actionplan_update");
  const { gridState, refreshTable } = useActionTable();
  // const  gridState  = {};
  const appContext = useContext(ActionContext);
  const { action, setAction } = appContext;
  const [editableRowId, setEditableRowId] = useState(false);

  const [newData, setNewData] = useState([]);

  const classes = useStyles();
  console.log("RTWalls");
  useEffect(() => {
    console.log("use effect gridState.data");
    setNewData(gridState.data);
  }, [gridState.data]);

  function indexFinder(rowId) {
    const indexOfId = newData.findIndex((obj) => obj.id == rowId);

    return indexOfId;
  }
  const columns = [
    {
      name: "Nom",
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: "Surface",
      selector: (row) => row.surface,
      sortable: true,
      cell: (row) =>
        editableRowId === row.id ? (
          <IntInput
            //inputTitle={actionVar[params].observations}
            intInput={newData[indexFinder(row.id)].surface}
            handleIntInputChange={(e) => handleChange(e, row.id)}
            name="surface"
          />
        ) : (
          row.surface
        ),
    },
    {
      name: "RTH",
      selector: (row) => row.thermicalresistance,
      sortable: true,
      cell: (row) =>
        editableRowId === row.id ? (
          <IntInput
            //inputTitle={actionVar[params].observations}
            intInput={newData[indexFinder(row.id)].thermicalresistance}
            handleIntInputChange={(e) => handleChange(e, row.id)}
            name="thermicalresistance"
          />
        ) : (
          row.thermicalresistance
        ),
    },
    {
      name: "deperditionpart",
      selector: (row) => row.deperditionpart,
      sortable: true,
      cell: (row) =>
        editableRowId === row.id ? (
          <FloatInput
            //inputTitle={actionVar[params].observations}
            floatInput={newData[indexFinder(row.id)].deperditionpart}
            handleFloatInputChange={(e) => handleChange(e, row.id)}
            name="deperditionpart"
          />
        ) : (
          row.deperditionpart
        ),
    },
    {
      name: "Valeur caractéristique (Uparoi)",
      selector: (row) => row.uwall,
      sortable: true,
      cell: (row) =>
        editableRowId === row.id ? (
          <IntInput
            //inputTitle={actionVar[params].observations}
            intInput={newData[indexFinder(row.id)].uwall}
            handleIntInputChange={(e) => handleChange(e, row.id)}
            name="uwall"
          />
        ) : (
          row.uwall
        ),
    },

    actionplanupdate && {
      name: "",
      sortable: false,
      width: "7rem",
      // eslint-disable-next-line react/button-has-type
      // eslint-disable-next-line react/display-name
      cell: (row) =>
        action.parameters.impact.walls.some((x) => x.id == row.id) && (
          <>
            <div className="actions-right">
              <Tooltip title="Editer le mur">
                <Button
                  onClick={editEnabled(row)}
                  color={editableRowId === row.id ? "info" : "success"}
                  className={classes.actionButton}
                >
                  {editableRowId === row.id ? (
                    <CheckIcon fontSize="large" />
                  ) : (
                    <EditIcon fontSize="large" />
                  )}
                </Button>
              </Tooltip>
            </div>
            <div className="actions-right">
              <Tooltip title="Recharger à partir des données du patrimoine">
                <Button
                  onClick={reloadWall(row)}
                  color={editableRowId === row.id ? "reddit" : "reddit"}
                  className={classes.actionButton}
                >
                  {editableRowId === row.id ? (
                    <AutorenewIcon fontSize="large" />
                  ) : (
                    <AutorenewIcon fontSize="large" />
                  )}
                </Button>
              </Tooltip>
            </div>
          </>
        ),
    },
  ];

  const handleChange = (e, id) => {
    const { name, value } = e.target;
    const indexOfId = newData.findIndex((obj) => obj.id == id);

    let newArray = [...newData];
    newArray[indexOfId][name] = value;

    setNewData(newArray);
  };

  const handleSelectedChange = ({ selectedRows }) => async () => {
    console.log("handleSelectedChange",selectedRows);
    if (actionplanupdate) {
      selectedRows.map((wall) => (wall.isSelected = true));
      setAction((prevState) => ({
        ...prevState,
        parameters: {
          ...prevState.parameters,
          impact: {
            ...prevState.parameters?.impact,
            walls: selectedRows,
          },
        },
      }));
    }
  };

  const editEnabled = (row) => async () => {
    editableRowId === row.id
      ? setEditableRowId(null)
      : setEditableRowId(row.id);
  };

  const reloadWall = (row) => async () => {
    let walls = [...action.parameters.impact.walls];

    let updatedWalls = walls.filter((item) => item.id !== row.id);

    setAction((prevState) => ({
      ...prevState,
      parameters: {
        ...prevState.parameters,
        impact: {
          ...prevState.parameters?.impact,
          walls: updatedWalls,
        },
      },
    }));

    refreshTable();
  };

  const contextMessage = {
    singular: "cloison",
    plural: "cloisons",
    message: "sélectionné(s)",
  };

  const selectableRowDisabled = (row) => {
    if (!actionplanupdate) {
      return row;
    }
  };

  const rowSelectCritera = (row) => 
  {
    return(row.isSelected);
  }
  return (
    <>
      <DataTable
          paginationRowsPerPageOptions={[10,20,30,50,100]}
        //noHeader={true}
        noDataComponent="Aucune paroi retrouvé dans le patrimoine"
        columns={columns}
        persistTableHead
        // subHeader
        progressPending={gridState.loading}
        progressComponent={<LinearProgress />}
        highlightOnHover
        dense
        selectableRows
        onSelectedRowsChange={(row)=>{handleSelectedChange(row)}}
        selectableRowSelected={(row)=>{rowSelectCritera(row)}}
        selectableRowsHighlight
        selectableRowDisabled={selectableRowDisabled}
        {...gridState}
        contextMessage={contextMessage}
      />
    </>
  );
};

export default RTWalls;
